module.exports = __webpack_public_path__ + "img/burger.a351dfbc.svg";